<template>
  <div id="op-report-page">
    <vx-card class="cHeight">

      <!-- HEADER 
      <h3 style="margin-bottom: 20px;">OP Reports</h3>-->

      
<vs-row class="mb-6">
  <vs-col class="w-1/6 topPad">
    <span class="label">From Date</span>
  </vs-col>

  <vs-col class="w-1/4">
    <flat-pickr v-model="fromDate" :config="dateConfig" class="w-full inputField" />
  </vs-col>
</vs-row>


<vs-row class="mb-6">
  <vs-col class="w-1/6 topPad">
    <span class="label">To Date</span>
  </vs-col>

  <vs-col class="w-1/4">
    <flat-pickr v-model="toDate" :config="dateConfig" class="w-full inputField" />
  </vs-col>
</vs-row>

      <!-- DOCTOR -->
      <vs-row class="mb-6">

        <vs-col class="w-1/6 topPad">
          <span class="label">Doctor</span>
        </vs-col>

        <vs-col class="w-1/4">
          <vs-select v-model="doctorId" class="w-full inputField">

            <vs-select-item
              v-for="doctor in doctorList"
              :key="doctor.id"
              :value="doctor.id"
              :text="doctor.name"
            />

          </vs-select>
        </vs-col>

      </vs-row>

      <!-- REPORT TYPE -->
      <vs-row class="mb-6">

        <vs-col class="w-1/6 topPad">
          <span class="label">Report Type</span>
        </vs-col>

        <vs-col class="w-2/3">

          <vs-radio v-model="reportCategory" vs-value="DETAIL">
             OP Report
          </vs-radio>

          <vs-radio v-model="reportCategory" vs-value="SUMMARY" style="margin-left:20px">
             OP Summary
          </vs-radio>

        </vs-col>

      </vs-row>

      <!-- EXPORT TYPE -->
      <vs-row class="mb-6">

        <vs-col class="w-1/6 topPad">
          <span class="label">Export Type</span>
        </vs-col>

        <vs-col class="w-2/3">

          <vs-radio v-model="reportType" vs-value="PDF">
            PDF
          </vs-radio>

          <vs-radio v-model="reportType" vs-value="EXCEL" style="margin-left:20px">
            Excel
          </vs-radio>

        </vs-col>

      </vs-row>

      <!-- BUTTONS -->
     <vs-row style="margin-top:30px;">

  <vs-col class="w-full sm:w-1/6"></vs-col>

  <vs-col class="w-full sm:w-1/3">
   <vs-button @click="printReport" style="margin-right:20px;">Preview</vs-button>

    <vs-button @click="clearForm">Clear</vs-button>
    
   

  </vs-col>

</vs-row>

    </vx-card>
  </div>
</template>
<script>

import '@/assets/scss/vuesax/extraComponents/agGridStyleOverride.scss'
import flatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';

export default {

components:{

flatPickr
},

data(){
    return {
    fromDate: null,
    toDate: null,

    doctorId: 0,
    doctorList: [],

    reportCategory: 'DETAIL',  // DETAIL / SUMMARY
    reportType: 'PDF'     ,
    dateConfig: {
  dateFormat: "d-m-Y"
}
  }
},
mounted(){



this.getDoctorList()

},
  methods:{
    formatDate(date) {
  if (!date) return null;

  // from dd-mm-yyyy → yyyy-mm-dd
  return date.split('-').reverse().join('-');
},
clearForm() {
  this.fromDate = null;
  this.toDate = null;

  this.doctorId = 0; // reset to "ALL"

  this.reportCategory = 'DETAIL'; // default
  this.reportType = 'PDF'; // default
},

async getDoctorList() {
  try {

    var request = {
      companyId: this.$session.get('companyId')
    };

    const response = await this.$http.post(
      "getdoctorlist",
      JSON.stringify(request),
      { headers: { "Content-Type": "application/json" } }
    );

    this.doctorList = [];

    
    this.doctorList.push({
      id: 0,
      name: "ALL"
    });

    response.data.data.forEach((value) => {
      this.doctorList.push(value);
    });

  } catch (error) {
    console.error("Error loading doctor list:", error);
 
}
  
},
printReport() {

  
  if (this.reportCategory === 'DETAIL' && this.reportType === 'PDF') {
    this.getPdfReport();
  }

   else if (this.reportCategory === 'DETAIL' && this.reportType === 'EXCEL') {
    this.getExcelReport();
  }
  

  else if (this.reportCategory === 'SUMMARY' && this.reportType === 'PDF') {
    this.getSummaryPdfReport();
  }

  else if (this.reportCategory === 'SUMMARY' && this.reportType === 'EXCEL') {
     this.getSummaryExcelReport();
  }
},
getPdfReport() {
    var request = {
        companyId: this.$session.get('companyId'),
        filter: {
            dateFrom: this.formatDate(this.fromDate),
            dateTo:this.formatDate(this.toDate),
            doctorId:this.doctorId  
        }
    }

    this.$http.post(
        "getopreportpdf",   
        JSON.stringify(request),
        {
            headers: {
                "Content-Type": "application/json"
            }
        }
    )
    .then(response => {
        console.log("pdf", response.data);

        window.open(response.data.data.filePath);
    });
},
getExcelReport() {

  var request = {
    companyId: this.$session.get('companyId'),
    filter: {
      dateFrom: this.formatDate(this.fromDate),
      dateTo: this.formatDate(this.toDate),
      doctorId: this.doctorId  
    }
  }

  this.$http.post(
    "getopreportxls",
    JSON.stringify(request),
    {
      headers: {
        "Content-Type": "application/json"
      }
    }
  )
  .then(response => {
    console.log("excel", response.data);

    window.open(response.data.data.filePath);
  });
},
getSummaryPdfReport() {

  var request = {
    companyId: this.$session.get('companyId'),
    filter: {
      dateFrom: this.formatDate(this.fromDate),
      dateTo: this.formatDate(this.toDate),
      doctorId: this.doctorId  
    }
  }

  this.$http.post(
    "getopsummaryreportpdf",   
    JSON.stringify(request),
    {
      headers: {
        "Content-Type": "application/json"
      }
    }
  )
  .then(response => {
    console.log("summary pdf", response.data);

    window.open(response.data.data.filePath);
  });
},
getSummaryExcelReport() {

  var request = {
    companyId: this.$session.get('companyId'),
    filter: {
      dateFrom: this.formatDate(this.fromDate),
      dateTo: this.formatDate(this.toDate),
      doctorId: this.doctorId  
    }
  }

  this.$http.post(
    "getopsummaryreportxls",
    JSON.stringify(request),
    {
      headers: {
        "Content-Type": "application/json"
      }
    }
  )
  .then(response => {
    console.log("excel", response.data);

    window.open(response.data.data.filePath);
  });
},

}
}
</script>
<style scoped>
.cHeight {
  min-height: 80vh;   
}
.inputField {
  height: 36px;
  width: 100%;
}
.label {
  font-size: 13.2px;
  font-weight: 600;
  padding-top: 6px;
  display: inline-block;
}
</style>